module.exports = __webpack_public_path__ + "img/1.15620d5a.png";